import styled from 'styled-components';

export const CalculatorLayoutStyle = styled.div`
  display: block;
  iframe {
    width: 100%;
    height: 600px;
    border: 0;
  }
  p {
    color:#314259;
    line-height: 24px;
    margin: 20px 0;
    font-size: 18px;
    font-weight: 500;
  }
  
  table tr:first-of-type td{
      background: #B7D5FE !important;
  }

  .table tr td p span{
    display:flex;
    justify-content: center;
  }

  tbody {
    tr:first-child {
    background: #B7D5FE;
      td {
        font-weight : 600;
      }
    }
  }

  table th{
    background: #B7D5FE;
  }

  td,th{
    font-size: 18px;
    padding: 10px !important;
    border: 1px solid #8EBEFD !important;
    border-collapse: collapse;
  }

  table{
    overflow: hidden;
    border-radius: 20px;
    border-collapse: separate;
    border: none;
    position: relative;
    border-spacing: 0;
    width: 100%;
    
    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 20px;
      height: 20px;
      border-color: rgb(142, 190, 253);
      border-style: solid;
    }
    
    /* Top-left corner */
    &::before {
      top: 0;
      left: 0;
      border-width: 1px 0 0 1px;
      border-radius: 20px 0 0 0;
    }
    
    /* Bottom-right corner */
    &::after {
      bottom: 0;
      right: 0;
      border-width: 0 1px 1px 0;
      border-radius: 0 0 20px 0;
    }
  }
  
  /* Additional pseudo-elements for the other two corners */
  table > tbody::before,
  table > tbody::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
    border-color: rgb(142, 190, 253);
    border-style: solid;
  }
  
  /* Top-right corner */
  table > tbody::before {
    top: 0;
    right: 0;
    border-width: 1px 1px 0 0;
    border-radius: 0 20px 0 0;
  }
  
  /* Bottom-left corner */
  table > tbody::after {
    bottom: 0;
    left: 0;
    border-width: 0 0 1px 1px;
    border-radius: 0 0 0 20px;
  }

  .table{
    display: block;
    width: 100%;
    overflow-x: auto;
    border: 1px solid #8EBEFD;
    border-radius:20px;
    -ms-overflow-style: none;
      ::-webkit-scrollbar {
        padding: 10px;
      }
  }
  
  tbody tr:nth-of-type(even) {
  background-color: #F3F8FF
}

  tbody tr:nth-of-type(odd) {
  background-color: #FFFFFF
}

  @media (max-width: 768px) {
    /* Fix for corner borders in mobile view */
    table::before,
    table::after,
    table > tbody::before,
    table > tbody::after {
      z-index: 10; /* Ensure corners appear above other elements */
    }
    
    /* Specifically fix the bottom-left corner for mobile */
    table > tbody::after {
      position: fixed; /* Use fixed positioning in mobile */
      bottom: 0;
      left: 0;
      width: 20px;
      height: 20px;
      border-width: 0 0 1px 1px;
      border-radius: 0 0 0 20px;
    }

    table tr:first-of-type td{
        background: #B7D5FE !important;
    }
    table tr:first-of-type td:first-of-type{
    background: #B7D5FE !important;
    }

    .table tr td:first-child {
      background: white;
      position: sticky;
      max-width: 200px;
      min-width: 150px;
      text-wrap: initial;
      left: -1px;
      z-index: 1;
      box-shadow: inset -2px 0 2px -2px #8EBEFD; 
    }
    .table tr td{
      white-space: nowrap;
      text: center;
      max-width: 250px;
      min-width: 150px;
      text-wrap: initial;
    }
    .table tr td:first-child p{
    width: 150px;
    text-wrap: wrap;
    margin: 4px;
    }
    thead tr th:first-child{
      position: sticky;
      left: -1px;
      z-index: 1;
      background: #B7D5FE;
      border: 1px solid #8EBEFD !important;
      box-shadow: inset -2px 0 2px -2px #8EBEFD;     
      max-width: 200px;
      min-width: 150px;
      text-wrap: initial;
    }
    tbody {
      tr td:first-child {
        background: white;
        position: sticky;
        left: -1px;
        z-index: 1;
        box-shadow: inset -2px 0 2px -2px #8EBEFD;
         max-width: 200px;
        min-width: 150px;
        text-wrap: initial;
      }
    }
      tbody tr:nth-of-type(even) td:first-child {
      background-color: #F3F8FF
    }

      tbody tr:nth-of-type(odd) td:first-child {
      background-color: #FFFFFF
    }
  }
  @media (min-width:769px)
  {
    table{
      width: 100%;
    }
    .table{
      width: 100%;
    }
  }

  .grey-block {
    background: #d0e4fe;
    padding: 30px;
  }
  h1{
    font-size: 28px;
  }
  h2 {
    margin: 36px 0 24px;
    font-size: 24px;
    line-height: 100%;
  }
  h2.faq-title{
    margin: 0;
    font-size: 20px;
    line-height: 100%;
    font-weight: 600;
  }
  h3 {
    margin: 36px 0 24px;
    font-size: 20px;
    line-height: 100%;
  }
    h4 {
    margin: 36px 0 24px;
    font-size: 18px;
    line-height: 100%;
  }
  ol,
  ul,
  li {
    margin: 10px;
    font-weight: 500;
    line-height: 24px;
    font-size: 18px;
    list-style: auto;
  }
  ul, li {
    list-style: disc;

  }
  a span u , a span strong, a span {
    color : #337ab7 !important;
  }

  .table{
    display: block;
    width: 100%;
    overflow-x: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
    ::-webkit-scrollbar {
      display:none;
    }
  }
  
  table {
    border-spacing: 0;
    width: 100%;
    border-radius: 5px;
    overflow-x: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
    ::-webkit-scrollbar {
      display:none;
    }
}
  }
  table th,
  table td {
    line-height: 24px;
    margin: 10px 0;
    font-size: 18px;
    padding: 10px;
    border: 1px solid #ddd;
  }
    table th{
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
  }
  }
  table thead {
    background-color: rgb(242, 242, 242) !important;
    font-weight: 700;
    tr {
      padding: 10px 0;
    }
  }
  tbody {
    tr:first-child {
      background: #dfdfdf59;
      td {
        font-weight : 600;
        font-size: 18px;
        line-height: 24px;
      }
    }
  }

    table tr:first-of-type td:first-of-type{
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
  }

  h2 *{
    line-height: inherit;
    font-size: inherit;
    font-weight: inherit;
  }
  
  h3 *{
    line-height: inherit;
    font-size: inherit;
    font-weight: inherit;
  }

  h4 *{
    line-height: inherit;
    font-size: inherit;
    font-weight: inherit;
  }

  .accordion-detail-panel *{
    line-height: inherit;
    font-size: inherit;
    font-weight: inherit;
  }

  li *{
    line-height: inherit;
    font-size: inherit;
    font-weight: inherit;
  }

  .rc-component {
    padding: 5px 10px;
    margin: 20px 0;
    border: solid 1px #dfdfdf82;
    border-radius: 5px;
    background-color : #78a9ea82;
    h2, h3 {
      margin: 10px 0;
    }
  }
  .youtube-player {
    border-radius: 10px;
    border: 1px solid rgba(51, 51, 51, 0.1);
    overflow: hidden;
    z-index: 1;
    margin: 50px 0;
  }
  b, strong {
    color: #314259;
  }
  
  .accordion-header-content {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
  }
  
  .accordion-detail-panel {
    font-weight: 400;
  }
  
  p * {
    line-height: inherit;
    font-size: inherit;
    font-weight: inherit;
  }
  
  td * {
    line-height: inherit;
    font-size: inherit;
    font-weight: inherit;
  }
  
  th * {
    line-height: inherit;
    font-size: inherit;
    font-weight: inherit;
  }
  
  li strong {
    font-weight: 700;
  }
  
  p strong {
    font-weight: 700;
  }
  
  td strong {
    font-weight: 600;
  }

  @media (max-width: 768px) {
    p {
      line-height: 24px;
      font-size: 16px;
      font-weight: 400;
    }
    li {
      line-height: 24px;
      font-size: 16px;
      font-weight: 400;
    }
    table td {
      line-height: 22px;
      font-size: 14px;
      font-weight: 400;
    }
    h2 { font-size: 20px; line-height: 28px; font-weight: 700; }
    h3 { font-size: 18px; line-height: 100%; font-weight: 700; }
    h4 { font-size: 18px; line-height: 100%; font-weight: 700; }
    h2.faq-title {
      margin: 0;
      font-size: 20px;
      line-height: 100%;
      font-weight: 700;
    }
  }
`;
